export default () => ({
  showSold: true,

  init() {
    if (window.innerWidth < 768) {
      this.showSold = false;
    }
  },
});
